export const NAV_LINKS = [
  { id: "home", label: "HOME", type: "anchor" },
  { id: "chi", label: "CHI", type: "anchor" },
  { id: "cosa", label: "COSA", type: "anchor" },
  { id: "come", label: "COME", type: "anchor" },
  { id: "progetti", label: "PROGETTI", type: "route", to: "/progetti" },
  { id: "contatti", label: "CONTATTI", type: "anchor" },
];

export const CONTACT = {
  email: "startpointagency@gmail.com",
  phoneDisplay: "+39 392 355 5521",
  phoneRaw: "+393923555521",
  whatsapp: "https://wa.me/393923555521",
  instagram: "https://instagram.com/startpoint.agency",
  tiktok: "https://tiktok.com/@startpoint.agency",
  linkedin: "#",
  facebook: "#",
  piva: "IT05931300874",
  location: "Catania, Sicilia — Italia",
};

export const SERVICES = [
  {
    number: "01",
    title: "SOCIAL & CONTENT",
    items: ["Strategia social", "Gestione Instagram e TikTok", "Ideazione di format", "Content creation", "Video & Reel", "Copywriting", "Piani editoriali", "Community management", "Campagne pubblicitarie"],
  },
  {
    number: "02",
    title: "BRAND & DESIGN",
    items: ["Brand identity", "Rebranding", "Progettazione e restyling logo", "Grafiche", "Packaging", "Brochure e menu", "Materiale coordinato", "Comunicazione visiva"],
  },
  {
    number: "03",
    title: "DIGITAL & PERFORMANCE",
    items: ["Siti web", "Landing page", "Funnel", "SEO", "Advertising", "Influencer marketing", "Prenotazioni e ordini online", "Conversioni"],
  },
  {
    number: "04",
    title: "OFFLINE & VISIBILITY",
    items: ["Cartellonistica", "Insegne luminose", "LED wall", "Affissioni", "Stampa", "Allestimenti", "Materiali pubblicitari"],
  },
];

export const COME_STEPS = [
  { number: "01", title: "ASCOLTIAMO", text: "Partiamo da una consulenza gratuita per conoscere l'attività, il mercato, i clienti, gli obiettivi e le difficoltà." },
  { number: "02", title: "ANALIZZIAMO", text: "Studiamo la presenza digitale, la comunicazione, i competitor, le opportunità e le priorità." },
  { number: "03", title: "PROGETTIAMO", text: "Proponiamo una direzione strategica: quali interventi riteniamo più utili, perché e con quali priorità." },
  { number: "04", title: "COSTRUIAMO", text: "Definiamo insieme un piano coerente con gli obiettivi e con le possibilità d'investimento." },
  { number: "05", title: "MISURIAMO ED EVOLVIAMO", text: "Monitoriamo i risultati disponibili, analizziamo cosa funziona e aggiorniamo la strategia quando serve." },
];

export const PROJECTS = [
  {
    slug: "mister-kebab",
    client: "MISTER KEBAB",
    location: "CATANIA",
    sector: "Food & Beverage",
    video: "/videos/mr-kebab-ig.mp4",
    poster: "/posters/mr-kebab-ig.jpg",
    gallery: [{ video: "/videos/mr-kebab.mp4", poster: "/posters/mr-kebab.jpg" }],
    stat: "190K+ LIKE",
    punto: "Un'attività food locale che voleva aumentare la propria riconoscibilità, raggiungere un pubblico più ampio e trasformare la visibilità in opportunità concrete per il punto vendita e per gli ordini.",
    obiettivo: "Rendere Mister Kebab immediatamente riconoscibile e trasformare l'attenzione social in clienti reali, in store e a domicilio.",
    strategia: "Un progetto di comunicazione continuativo, incentrato su contenuti video originali, intrattenimento, format social, promozioni e valorizzazione del brand. Online e offline integrati, per rendere la comunicazione coerente in ogni punto di contatto con il cliente. La strategia non si limita alla viralità: unisce social, identità del brand, promozioni, punto vendita e fidelizzazione.",
    attivita: ["Strategia e gestione dei contenuti social", "Produzione di video e contenuti organici", "Format creativi pensati per il pubblico", "Promozioni e iniziative commerciali", "Tessere fedeltà dedicate agli studenti", "Volantini e materiali promozionali", "Brand awareness in manifestazioni sportive", "Rebranding con nuovo logo e colori", "Restyling del locale", "Progettazione e realizzazione dell'insegna luminosa", "Affissioni interne in forex"],
    risultati: [
      { text: "+20% di conversioni negli ordini a domicilio online", tag: "Dato riportato dal cliente" },
      { text: "6.286 follower e 190.000+ like su TikTok", tag: "Rilevazione ottobre 2026" },
      { text: "Progetto attivo da circa un anno, in continua evoluzione", tag: "In corso" },
    ],
    attribution: "RISULTATI OTTENUTI SENZA CAMPAGNE SPONSORIZZATE SUI SOCIAL",
    links: [
      { label: "TikTok", url: "https://www.tiktok.com/@misterkebabcatania" },
      { label: "Instagram", url: "https://www.instagram.com/misterkebabcatania/" },
    ],
  },
  {
    slug: "drago-ramen",
    client: "DRAGO RAMEN",
    location: "CATANIA",
    sector: "Food & Beverage",
    video: "/videos/drago-ramen-hero.mp4",
    poster: "/posters/drago-ramen-hero.jpg",
    gallery: [{ video: "/videos/drago-ramen.mp4", poster: "/posters/drago-ramen.jpg" }],
    stat: "3.9K FOLLOWER",
    punto: "Il cliente è arrivato dopo una precedente collaborazione con un'altra agenzia, con l'esigenza di trovare maggiore continuità nella comunicazione e un sistema di marketing più integrato.",
    obiettivo: "Dare continuità alla presenza social e costruire un percorso digitale che aiuti gli utenti a passare dalla scoperta del ristorante all'azione.",
    strategia: "Continuità della presenza social e iniziative mirate di influencer marketing, affiancate da un ecosistema digitale completo: sito web, funnel, menu, ordini e prenotazioni integrati in un unico percorso.",
    attivita: ["Gestione e sviluppo dei profili social", "Creazione di contenuti video", "Campagne mirate di influencer marketing", "Campagne pubblicitarie sponsorizzate", "Sviluppo del sito dragoramen.it", "Funnel digitale dedicato", "Integrazione del menu completo", "Ordini da asporto e a domicilio", "Prenotazione diretta del tavolo", "Integrazione dei punti di contatto digitali"],
    risultati: [
      { text: "3.980 follower su TikTok", tag: "Rilevazione ottobre 2026" },
      { text: "Oltre 2.000 follower complessivi sui due profili social", tag: "Dato fornito dal cliente" },
      { text: "Contenuti, sito, prenotazioni e ordini integrati in un unico sistema", tag: "Ecosistema digitale" },
    ],
    attribution: "MIX DI ATTIVITÀ ORGANICHE E CAMPAGNE SPONSORIZZATE",
    links: [
      { label: "TikTok", url: "https://www.tiktok.com/@dragoramen" },
      { label: "Instagram", url: "https://www.instagram.com/dragoramencatania/" },
      { label: "Sito web", url: "https://dragoramen.it/" },
    ],
  },
  {
    slug: "vb-beauty",
    client: "VB BEAUTY LAB ACADEMY",
    location: "BEAUTY",
    sector: "Beauty & Formazione",
    video: "/videos/vb-beauty.mp4",
    poster: "/posters/vb-beauty.jpg",
    gallery: [],
    stat: "IN EVOLUZIONE",
    punto: "La cliente cercava un partner capace di comprendere e tradurre in comunicazione la propria visione, la propria identità e il modo in cui desiderava presentare il brand. Il lavoro è partito dall'ascolto.",
    obiettivo: "Costruire progressivamente un'identità comunicativa più riconoscibile, fedele alla visione della fondatrice.",
    strategia: "Contenuti specifici per catturare l'attenzione del pubblico, affiancati ad attività promozionali, campagne mirate e iniziative di marketing. Il progetto è in evoluzione e punta a consolidare progressivamente riconoscibilità e crescita del brand.",
    attivita: ["Analisi e sviluppo dell'identità comunicativa", "Video creativi realizzati ad hoc", "Content creation", "Crescita organica dei profili", "Campagne sponsorizzate mirate", "Promozioni", "Funnel dedicati con il reparto IT della cliente", "Event marketing", "Coordinamento tra contenuti social e iniziative commerciali"],
    risultati: [
      { text: "Identità comunicativa costruita progressivamente nel tempo", tag: "Percorso" },
      { text: "Progetto in evoluzione: le metriche verranno pubblicate appena verificabili", tag: "In corso" },
    ],
    attribution: "PROGETTO IN EVOLUZIONE",
    links: [
      { label: "TikTok", url: "https://www.tiktok.com/@vbbeautylabacademy" },
      { label: "Instagram", url: "https://www.instagram.com/vbbeautylabacademy/" },
    ],
  },
  {
    slug: "cirolli",
    client: "PANIFICIO CIROLLI",
    location: "GRAVINA DI CATANIA",
    sector: "Food & Bakery",
    video: "/videos/cirolli.mp4",
    poster: "/posters/cirolli.jpg",
    gallery: [],
    stat: "+1.6K FOLLOWER",
    punto: "Un progetto focalizzato principalmente su TikTok, con l'obiettivo di ampliare il pubblico e integrare la presenza digitale con strumenti pratici per il business.",
    obiettivo: "Far crescere il profilo e rendere l'offerta più accessibile ai clienti, con strumenti digitali concreti.",
    strategia: "Crescita del profilo TikTok e sviluppo di strumenti utili al business: menu digitale, delivery e materiali fisici. La visibilità social si integra con ciò che serve davvero al punto vendita.",
    attivita: ["Strategia e produzione di contenuti TikTok", "Crescita organica del profilo", "Campagne sponsorizzate mirate", "Menu digitale con QR code", "Apertura e gestione delle piattaforme di delivery", "Affissioni in forex"],
    risultati: [
      { text: "Da circa 3.000 a 4.632 follower su TikTok in pochi mesi", tag: "Dato cliente + rilevazione ottobre 2026" },
      { text: "25.200+ like totali su TikTok", tag: "Rilevazione ottobre 2026" },
      { text: "Visibilità social integrata con menu digitale, delivery e materiali fisici", tag: "Online + offline" },
    ],
    attribution: "CRESCITA DA MIX DI ORGANICO E SPONSORIZZATE MIRATE",
    links: [
      { label: "TikTok", url: "https://www.tiktok.com/@panificio.cirolli" },
      { label: "Menu digitale", url: "https://canva.link/menupanificiocirolli" },
    ],
  },
];

export const OTHER_PROJECTS = [
  {
    slug: "kebab-king",
    client: "KEBAB KING",
    location: "CALTAGIRONE",
    video: "/videos/kebab-king.mp4",
    poster: "/posters/kebab-king.jpg",
    text: "Lancio social di un nuovo fast food: 10.500+ visualizzazioni sul primo video (rilevazione agosto 2026).",
    link: "https://www.tiktok.com/@kebabkingcalta",
  },
  {
    slug: "gambian-house",
    client: "YOUR GAMBIAN HOUSE",
    location: "HOSPITALITY",
    video: "/videos/gambian-house.mp4",
    poster: "/posters/gambian-house.jpg",
    text: "Lancio da zero del brand su TikTok e Instagram: identità, contenuti e presenza digitale.",
    link: "https://www.tiktok.com/@yourgambianhouse",
  },
];

export const SETTORE_OPTIONS = [
  "Food & Beverage",
  "Retail / Negozio",
  "Automotive",
  "Beauty & Wellness",
  "Servizi / Professionisti",
  "Horeca / Ristorazione",
  "E-commerce",
  "Altro",
];

export const SERVIZIO_OPTIONS = [
  "Social Media Marketing",
  "Content creation / Video",
  "Brand identity / Design",
  "Sito web / Landing page / Funnel",
  "Advertising / Google / SEO",
  "Comunicazione offline",
  "Strategia a 360°",
  "Non lo so ancora — voglio capirlo insieme",
];

export const BUDGET_OPTIONS = [
  "Da definire insieme",
  "Fino a €500 / mese",
  "€500 – €1.500 / mese",
  "€1.500 – €3.000 / mese",
  "Oltre €3.000 / mese",
  "Progetto una tantum",
];
